import React from 'react';
import { observer } from 'mobx-react';

import { useStore } from 'stores';
import { Toggle } from 'components/Form/Toggle';


interface Props
{
  featureId: number,
  scope: string,
  isToggleOn?: boolean,
}

export const FullyBoundedToggleCreator: React.FC<Props> = observer(({featureId, scope, isToggleOn}) =>
{
  const { toggleStore} = useStore();

  const createToggleHandler = async () =>
  {
    await toggleStore.createAsync(featureId, scope, !isToggleOn);
  }

  return (
    <div className={['toggle-creator', isToggleOn === undefined ? 'unknown' : ''].join(' ')}>
      <Toggle value={isToggleOn || false} onClick={createToggleHandler} disabled={toggleStore.toggle.isLoading} />
    </div>
  );
});